import { useEffect, useRef } from 'react';

/** Runs `onVisible` when the tab becomes visible again (iOS scenePhase .active). */
export function useVisibilityRefresh(onVisible: () => void): void {
  const ref = useRef(onVisible);
  ref.current = onVisible;
  useEffect(() => {
    const handler = () => {
      if (document.visibilityState === 'visible') ref.current();
    };
    document.addEventListener('visibilitychange', handler);
    return () => document.removeEventListener('visibilitychange', handler);
  }, []);
}
